<template>
  <div>
    <q-splitter v-model="splitterModel" style="height: 400px">

      <template v-slot:before>
        <q-tabs v-model="tab" vertical class="text-teal">
          <q-tab name="mqtt" icon="hub" label="MQTT" />
          <q-tab name="alarms" icon="notifications" label="Alarms" />
          <q-tab name="usb" icon="usb" label="USB" />
        </q-tabs>
      </template>

      <template v-slot:after>
        <q-tab-panels v-model="tab" animated vertical transition-prev="jump-up" transition-next="jump-up">
          <q-tab-panel name="mqtt">
            <div class="text-h4 q-mb-md">MQTT</div>
            <MQTTConfiguration />
          </q-tab-panel>

          <q-tab-panel name="alarms">
            <div class="text-h4 q-mb-md">Alarms</div>
            <AlarmConfiguration />
          </q-tab-panel>

          <q-tab-panel name="usb">
            <div class="text-h4 q-mb-md">Serial</div>
            <SerialConfiguration />
          </q-tab-panel>
        </q-tab-panels>
      </template>

    </q-splitter>
  </div>
</template>

<style></style>

<script>
import { ref } from 'vue'
import MQTTConfiguration from './MQTTConfiguration.vue'
import AlarmConfiguration from './AlarmConfiguration.vue'
import SerialConfiguration from './SerialConfiguration.vue'

export default {
  name: 'GeneralConfigurations',
  components: {
    MQTTConfiguration,
    AlarmConfiguration,
    SerialConfiguration,
  },
  setup() {
    return {
      tab: ref('mqtt'),
      splitterModel: ref(20)
    }
  }
}


</script>
